export default {
    stockOrderList: [],
    emptyStockOrder: {},
    totalDataRow:0 
}
  